import {
  axisTop,
  basis_default,
  line_default
} from "./chunk-Z2ZITHT4.js";
import {
  linear
} from "./chunk-4OLM3KSB.js";
import {
  decimalPlacesUntilFirstNonZero
} from "./chunk-TLT4YIG3.js";
import {
  brushX
} from "./chunk-5R63Q5KH.js";
import {
  rgb
} from "./chunk-Q5RDQNIT.js";

// dom/violinRenderer.js
var violinRenderer = class {
  constructor({
    holder,
    rd,
    radius = 10,
    width = 500,
    height = 100,
    shiftx = 20,
    shifty = 20,
    callback = null,
    scaleFactor = 1
  }) {
    this.holder = holder;
    this.rd = rd;
    this.vd = rd.charts?.[""]?.plots?.[0];
    if (!this.vd) throw "No density plot data to render.";
    this.width = width;
    this.height = height;
    this.radius = radius;
    this.callback = callback;
    this.shiftx = shiftx;
    this.shifty = shifty;
    this.svg = holder.append("svg").attr("width", `${width + 50}px`).attr("height", `${height + 50}px`);
    this.axisScale = linear().domain([rd.min, rd.max]).range([0, width]);
    this.axisScaleUI = linear().domain([rd.min * scaleFactor, rd.max * scaleFactor]).range([0, width]);
    this.wScale = linear().domain([this.vd.density.densityMax, this.vd.density.densityMin]).range([height * 0.45, 0]);
  }
  render() {
    this.svg.selectAll("*").remove();
    this.violinG = this.svg.append("g").attr("transform", `translate(${this.shiftx}, ${this.height / 2 + this.shifty})`);
    this.brushG = this.svg.append("g").attr("transform", `translate(${this.shiftx}, ${this.shifty})`);
    this.scaleG = this.svg.append("g").attr("transform", `translate(${this.shiftx}, ${this.shifty})`);
    this.scaleG.call(axisTop(this.axisScaleUI).tickValues(this.axisScaleUI.ticks()));
    this.renderArea(false);
    this.renderArea(true);
    if (this.vd.src) {
      this.violinG.append("image").classed("sjpp-beans-img", true).attr("xlink:href", this.vd.src).attr("transform", `translate(0, -${this.radius / 2})`).attr("width", this.width);
    }
    if (this.callback)
      this.svg.append("g").call(
        brushX().extent([
          [this.shiftx, this.shifty],
          [this.width + this.shiftx, this.height + this.shifty]
        ]).on("end", async (event) => {
          const selection = event.selection;
          if (!selection) return;
          const range_start = this.axisScale.invert(selection[0] - this.shiftx);
          const range_end = this.axisScale.invert(selection[1] - this.shiftx);
          this.callback({ range_start, range_end });
        })
      );
  }
  renderArea(invert) {
    if (this.vd.densityMax == 0) return;
    const areaBuilder = line_default().curve(basis_default).x((d) => this.axisScale(d.x0)).y((d) => invert ? -this.wScale(d.density) : this.wScale(d.density));
    const color = this.vd.color || "#dddddd";
    this.violinG.append("path").style("fill", color).style("opacity", 0).attr("stroke", rgb(color).darker()).attr("stroke-width", 1).attr("stroke-linejoin", "round").style("opacity", "0.8").attr("d", areaBuilder(this.vd.density.bins));
  }
};

// dom/niceNumLabels.ts
function niceNumLabels(nums) {
  const sorted = nums.sort((a, b) => a - b);
  const abs = Math.abs(sorted[0] - sorted[sorted.length - 1]);
  const zeroDecimalNum = decimalPlacesUntilFirstNonZero(abs);
  const decimals2Show = abs >= 10 ? 0 : abs >= 1 ? 1 : zeroDecimalNum + 2;
  return nums.map((num) => {
    if (Math.abs(num) < 1 && decimals2Show == 0) return Number(num.toPrecision(1));
    return Number(num.toFixed(decimals2Show));
  });
}

export {
  violinRenderer,
  niceNumLabels
};
//# sourceMappingURL=chunk-7X6NF7NI.js.map
